import { render, staticRenderFns } from "./AddClassifyMaterial.vue?vue&type=template&id=10805702&scoped=true&"
import script from "./AddClassifyMaterial.vue?vue&type=script&lang=js&"
export * from "./AddClassifyMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AddClassifyMaterial.vue?vue&type=style&index=0&id=10805702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10805702",
  null
  
)

export default component.exports